import React from "react";

import {pluralize} from "@pg-mono/string-utils";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const RoomsCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    return <>{`${property.rooms} ${roomsPlural(property.rooms)}`}</>;
};

const roomsPlural = pluralize(["pokój", "pokoje", "pokoi"]);
import React from "react";

import {pluralize} from "@pg-mono/string-utils";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const RoomsCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    return <>{`${property.rooms} ${roomsPlural(property.rooms)}`}</>;
};

const roomsPlural = pluralize(["pokój", "pokoje", "pokoi"]);
